module.exports = __webpack_public_path__ + "static/media/edulogo.f14f4c4d.png";